import { Injectable, inject } from '@angular/core';
import { TodoEntryModel } from '../../../core/models/todo-planner/todo-entry.model';
import { SlotHandlerService } from '../../../core/services/features/fix-interval-planner/slot-handler.service';
import { mapToArray } from '../../../shared/functions/map-functions';
import { Slot } from '../../calendar/components/time-block/calculation/geometry/slot/slot';
import { TimeBlockIntersectionService } from '../../calendar/components/time-block/calculation/intersection/time-block-intersection.service';
import { ITimeBlockComponentItem } from '../../calendar/components/time-block/types/time-block-component-item-types';
import { TodoEntryConverter } from '../converter/todo-entry.converter';

@Injectable({
  providedIn: 'root',
})
export class TodoPlannerParallelIndexCalculatorService {
  // DI
  private readonly slotHandlerService = inject(SlotHandlerService);
  private readonly timeBlockIntersectionService = inject(TimeBlockIntersectionService);

  public calculate(todoEntryModels: Map<string, TodoEntryModel[]>): void {
    const slots = new Array<Slot>();
    const array = mapToArray(todoEntryModels, true) as TodoEntryModel[];
    const timeBlocks = array.map((todoEntryModel: TodoEntryModel) =>
      TodoEntryConverter.toITimeBlockComponentItem(todoEntryModel),
    );

    // fill in fix interval time blocks first
    this.slotHandlerService.orderFixIntervalTimeBlocks(timeBlocks);
    timeBlocks.forEach((timeBlock: ITimeBlockComponentItem) => {
      if (!timeBlock.timeBlockModel.fixInterval) {
        return;
      }

      this.slotHandlerService.assignTimeBlockToSlot(
        timeBlock,
        slots,
        this.timeBlockIntersectionService,
        true,
      );
    });

    this.slotHandlerService.updateGeometryHorizontalSlots(slots);
  }
}
